import { render, staticRenderFns } from "./ErstelleKunde.vue?vue&type=template&id=8a18c488&"
import script from "./ErstelleKunde.vue?vue&type=script&lang=js&"
export * from "./ErstelleKunde.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports